import widgetString from "../../public/widget.js?raw";

const integrationsFunc = (screenId: string) => ({
  jsContent: [widgetString],
  onScriptLoad: (apply: Function) => {
    apply(`document.body.innerHTML += "<a href='' data-id=${screenId} id=${screenId}></a>";`);
    apply(`renderFeedbackWidget("${screenId}", {
      "question_type": "multiple_choice",
      "book_id": "BRNT-XUF8BS197",
      "page_id": "e8d95270-ee22-11ef-a062-1945859a760d",
      "questionId": "aacb26a1-32eb-4a15-8ce9-7ddbf7762a78",
      "question_stem": "Which statement accurately describes how organic compounds act as fuels in catabolic pathways?",
      "element_id": "898cd7df-d8f1-48b0-a512-c04bb4d484d1",
      "relevant_text": "Catabolic pathways do not directly move flagella, pump solutes across membranes, polymerize monomers, or perform other cellular work",
      "max_attempts": 3,
      "attempts": [
        {
          "attempted_at": "2025-08-15T00:00:00.000Z",
          "answer_id": "2"
        },
        {
          "attempted_at": "2025-08-16T00:00:00.000Z",
          "answer_id": "3"
        }
      ],
      "options": [
        {
          "feedback": "Organic compounds must be broken down to release energy; they aren't converted directly into ATP.",
          "distractor": "They only act as fuels when they are converted directly into ATP without any breakdown.",
          "correct_choice": "No",
          "id": 1
        },
        {
          "feedback": "Catabolism breaks bonds to release energy, not form new ones.",
          "distractor": "They store energy by forming new covalent bonds during catabolism.",
          "correct_choice": "No",
          "id": 2
        },
        {
          "feedback": "Exactly! Organic compounds release energy in exergonic reactions during catabolism.",
          "distractor": "They participate in exergonic reactions, releasing potential energy stored in their bonds.",
          "correct_choice": "Yes",
          "id": 3
        }
      ]
    }
    )`);
  },
});

export { integrationsFunc };
